import { render, staticRenderFns } from "./CubeFlooring.vue?vue&type=template&id=af88b9e0&scoped=true&"
import script from "./CubeFlooring.vue?vue&type=script&lang=js&"
export * from "./CubeFlooring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af88b9e0",
  null
  
)

export default component.exports